export default __webpack_public_path__ + "static/media/Stalker's Belt of the Firebringer.cc05b8ad.jpg";